import { render } from "./ProductWhoBoughtSkeleton.vue?vue&type=template&id=636f7168&scoped=true"
import script from "./ProductWhoBoughtSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductWhoBoughtSkeleton.vue?vue&type=script&lang=js"

import "./ProductWhoBoughtSkeleton.vue?vue&type=style&index=0&id=636f7168&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636f7168"]])

export default __exports__